import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Avatar, FormControl, FormHelperText, FormLabel, Grid, IconButton, InputAdornment, OutlinedInput, Stack } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, CardBody, Container } from "reactstrap";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import CustomTextField from "../../components/Form/CustomTextField";
import Helpers from "../../helpers/helpers";
import { getAttachment, resetProfileState, updateProfile, updateUserPassword, verify_admin } from "../../store/actions";


const UserProfile = ({ userProfile, editUserProfile, editUserPwd, profileImgBase64, userPermission }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fileInputRef = useRef();

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("edit-setting") && setEditable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const defaultValues = {
        fullName: "",
        email: "",
        phone: "",
        gender: "Choose",
        Nationality: "Choose",
        role: "Choose",
        password: "",
        status: "",
        joinedDate: "",
    }

    const { ID } = useParams();

    const [values, setFormValues] = useState(defaultValues);
    const [profileImg, setProfileImg] = useState();
    const [loading, setIsLoading] = useState(false);
    const [editable, setEditable] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);
    const [error, setError] = useState();
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        if (profileImgBase64?.code === 'success') {
            setProfileImg(profileImgBase64?.base64_data);
        } else {
            setProfileImg();
        }
    }, [profileImgBase64])

    useEffect(() => {
        if (userProfile?.profile_photo_path) {
            dispatch(getAttachment({ attachment: userProfile?.profile_photo_path }));
        }
        setFormValues({
            fullName: userProfile?.name || "",
            email: userProfile?.email || "",
            phone: userProfile?.phone || "",
        })
    }, [userProfile])

    useEffect(() => {
        if (editUserProfile?.code === 'success') {
            setNotification({
                open: true,
                msg: 'Profile updated successfully',
                type: 'success'
            })
            dispatch(resetProfileState());
            dispatch(verify_admin());
        } else if (editUserProfile?.code === 'invalid_field') {
            setNotification({
                open: true,
                msg: 'Make sure that all the required field is not empty.',
                type: 'warning'
            })
            setError(editUserProfile.errors)
        }
        setIsLoading(false);
    }, [editUserProfile])

    useEffect(() => {
        if (editUserPwd?.code === 'success') {
            setNotification({
                open: true,
                msg: 'Password updated successfully',
                type: 'success'
            })
        } else if (editUserPwd?.code === 'invalid_field') {
            setNotification({
                open: true,
                msg: 'Make sure that the confirm password field matches the value of the password field',
                type: 'warning'
            })
        } else if (editUserPwd?.code === 'invalid_current_password') {
            setNotification({
                open: true,
                msg: editUserPwd?.data?.message,
                type: 'warning'
            })
        }
        setIsLoading(false);
    }, [editUserPwd])

    const handleUserProfileSave = () => {
        setIsLoading(true);
        let payload = {
            name: values.fullName,
            phone: values.phone,
            email: values.email,
            profile_photo: profileImg,
        }
        dispatch(updateProfile(payload));
    }

    const handleUpdatePassword = () => {
        if (values.current_password && values.password && values.password_confirmation) {
            setIsLoading(true);
            let payload = {
                current_password: values.current_password || '',
                new_password: values.password || '',
                new_password_confirmation: values.password_confirmation || ''
            }
            dispatch(updateUserPassword(payload));

        } else {
            setNotification({
                open: true,
                msg: 'Make sure that all the required field is not empty.',
                type: 'warning'
            })
        }
    }

    const onChangeFile = (file) => {
        if (Helpers.isFileSizeValid(file)) {
            Helpers.getBase64(file, (result) => {
                setProfileImg(result);
            });
        } else {
            setNotification({
                open: true,
                msg: "File size must be less than 1MB",
                type: 'warning'
            })
        }
        // clear the upload file value
        fileInputRef.current.value = '';
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <LoadingDialog open={loading || !values?.email} />
                    <Notification notification={notification} setNotification={setNotification} />
                    <div className="header mb-3">{'Profile'}</div>
                    <Card className="p-3">
                        <CardBody>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4} pb={3}>
                                    <h5>Profile details</h5>
                                    <h6 className="subheader-2 mb-3">Enter your details, contact information and change your profile picture.</h6>
                                </Grid>

                                <Grid item xs={12} sm={8}>
                                    <Grid container spacing={2} pt={0}>
                                        <Grid item xs={12}>
                                            <div className="text-semibold">Avatar</div>
                                        </Grid>
                                        <Grid item xs={12} display={'flex'} alignItems={'center'} spacing={2}>
                                            <div style={{ marginRight: 16 }}>
                                                <Avatar alt="Profile Pic" src={profileImg && `data:image/jpeg;base64,${profileImg}`} sx={{ width: 64, height: 64 }} />
                                            </div>
                                            {editable && <div className="mb-2">
                                                <Grid container spacing={2}>
                                                    <Grid item lg={12} sm={12} display={'flex'} direction={{xs:"column", sm: "row"}} gap={1}>
                                                        <CustomButton
                                                            title={'Choose'}
                                                            press={() => document.getElementById("new-upload-file").click()}
                                                            backgroundColor={'#F2F2F2'}
                                                            textColor={'#101010'}
                                                            borderStyle={'1px solid #E3E8EE'}
                                                        />
                                                        {
                                                            profileImg &&
                                                            <CustomButton
                                                                title={'Remove'}
                                                                press={() => setProfileImg()}
                                                                backgroundColor={'white'}
                                                                textColor={'#101010'}
                                                                borderStyle={'1px solid #E3E8EE'}
                                                                // marginLeft={5}
                                                            />
                                                        }
                                                        <input
                                                            type="file"
                                                            id={"new-upload-file"}
                                                            ref={fileInputRef}
                                                            style={{ display: 'none' }}
                                                            accept="image/png, image/jpeg"
                                                            onChange={(e) => onChangeFile(e.target.files[0])}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={12} sm={12} className="pt-0">
                                                        <div className="setting-desc mt-2">
                                                            <div>JPG or PNG, 1MB Max.</div>
                                                        </div>
                                                    </Grid>
                                                </Grid>


                                            </div>}
                                        </Grid>
                                        <Grid item xs={12} >
                                            <CustomTextField
                                                title={'Name'}
                                                values={values.fullName}
                                                placeholder="Your Name"
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    fullName: e
                                                }))}
                                                disabled={!editable}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{(error?.name && error?.name[0]) || ""}</FormHelperText>}
                                        </Grid>

                                        <Grid item xs={12} >
                                            <CustomTextField
                                                title={'Email address'}
                                                values={values.email}
                                                placeholder="your.email@example.com"
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    email: e
                                                }))}
                                                disabled={true}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{(error?.email && error?.email[0]) || ""}</FormHelperText>}
                                        </Grid>

                                        <Grid item xs={12} >
                                            <CustomTextField
                                                title={'Phone number'}
                                                type={'phone'}
                                                values={values?.phone || ''}
                                                placeholder="65123456789"
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    phone: e
                                                }))}
                                                disabled={!editable}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{(error?.phone && error?.phone[0]) || ""}</FormHelperText>}
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                            {
                                editable &&
                                <Stack sx={{ flexDirection: { xs: "column-reverse", sm: "row" }, justifyContent: { xs: "center", sm: "flex-end" } }} justifyContent={"flex-end"} gap={2} pt={4}>
                                    <Button color="primary" className="w-md waves-effect waves-light" type="submit" onClick={() => handleUserProfileSave()}>Save Changes</Button>
                                </Stack>
                            }

                        </CardBody>
                    </Card>
                    {
                        editable &&
                        <Card className="p-3">
                            <CardBody>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4} pb={3}>
                                        <h5>Change Password</h5>
                                        <h6 className="subheader-2 mb-4">Change your password.</h6>
                                    </Grid>

                                    <Grid item xs={12} sm={8}>
                                        <Grid container spacing={2}>
                                            <>
                                                <Grid item xs={12} sx={{ display: { xs: "none", sm: "block" } }}></Grid>
                                                <Grid item xs={12} >
                                                    <FormControl variant="standard" fullWidth>
                                                        <FormLabel>Current Password</FormLabel>
                                                        <OutlinedInput
                                                            size="small"
                                                            value={values.current_password}
                                                            placeholder="Current password"
                                                            type={showCurrentPassword ? 'text' : 'password'}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={(e) => setShowCurrentPassword((show) => !show)}
                                                                        edge="end"
                                                                    >
                                                                        {showCurrentPassword ? <i className="font-size-24 ri-eye-line"></i> : <i className="ri-eye-close-line font-size-24"></i>}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                            onChange={(e) => {
                                                                setFormValues((prevValues) => ({
                                                                    ...prevValues,
                                                                    current_password: e.target.value,
                                                                }))
                                                            }}
                                                        />
                                                        {error && <FormHelperText sx={{ color: "red" }}>{error.password || ""}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} >
                                                    <FormControl variant="standard" fullWidth>
                                                        <FormLabel>New Password</FormLabel>
                                                        <OutlinedInput
                                                            size="small"
                                                            value={values.password}
                                                            placeholder="New password"
                                                            type={showPassword ? 'text' : 'password'}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={(e) => setShowPassword((show) => !show)}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <i className="font-size-24 ri-eye-line"></i> : <i className="ri-eye-close-line font-size-24"></i>}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                            onChange={(e) => {
                                                                setFormValues((prevValues) => ({
                                                                    ...prevValues,
                                                                    password: e.target.value,
                                                                }))
                                                            }}
                                                        />
                                                        {error && <FormHelperText sx={{ color: "red" }}>{error.password || ""}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>

                                                <Grid item xs={12} >
                                                    <FormControl variant="standard" fullWidth>
                                                        <FormLabel>Password confirmation</FormLabel>
                                                        <OutlinedInput
                                                            size="small"
                                                            placeholder="Password confirmation"
                                                            value={values.password_confirmation}
                                                            type={showRePassword ? 'text' : 'password'}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={(e) => setShowRePassword((show) => !show)}
                                                                        edge="end"
                                                                    >
                                                                        {showRePassword ? <i className="font-size-24 ri-eye-line"></i> : <i className="ri-eye-close-line font-size-24"></i>}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                            onChange={(e) => {
                                                                setFormValues((prevValues) => ({
                                                                    ...prevValues,
                                                                    password_confirmation: e.target.value,
                                                                }))
                                                            }}
                                                        />
                                                        {error && <FormHelperText sx={{ color: "red" }}>{error.password || ""}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            </>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {editable && <Stack sx={{ flexDirection: { xs: "column-reverse", sm: "row" }, justifyContent: { xs: "center", sm: "flex-end" } }} justifyContent={"flex-end"} gap={2} pt={4}>
                                    <Button color="primary" className="w-md waves-effect waves-light" type="submit" onClick={() => handleUpdatePassword()}>Save Changes</Button>
                                </Stack>}
                            </CardBody>
                        </Card>
                    }

                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Profile, General }) {
    return {
        userProfile: Login?.verifyAdmin?.user?.data?.profile,
        editUserProfile: Profile.editProfile,
        editUserPwd: Profile.editUserPwd,
        profileImgBase64: General.attachment,
        userPermission: Login.permissionArry,

    };
}

export default connect(mapStateToProps)(UserProfile);
